import {getGroundReport, getScrappedSnowReport, getSnowReport} from "../utils/RestAPI";
import {useEffect, useState} from "react";

export default function useResortSnowReport({dataID}) {
    const [isLoading, setIsLoading] = useState(true);
    const [isFetching, setIsFetching] = useState(true);
    const [reports, setReports] = useState({
        groundReport: {},
        snowReport: {},
        scrappedReport: {}
    })
    useEffect(() => {
        refetch();
    }, []);

    function refetch() {
        setIsFetching(true);
        return Promise
            .all([
                getGroundReport(dataID),
                getSnowReport(dataID),
                getScrappedSnowReport(dataID)
            ])
            .then((reports) => {
                setReports({
                    groundReport: reports[0],
                    snowReport: reports[1],
                    scrappedReport: reports[2]
                });
            })
            .finally(() => {
                setIsLoading(false);
                setIsFetching(false);
            });
    }

    return {
        groundReport: reports.groundReport['snow_report_html'] || reports?.groundReport['resort_snow_report'],
        snowReport: reports?.snowReport,
        scrappedReport: reports?.scrappedReport,
        isLoading: isLoading,
        refetch,
        isFetching: isFetching
    }
}